module.exports = __webpack_public_path__ + "img/schets-9.3f4fbe17.jpg";